<template>
  <div>
    <el-autocomplete
      v-model="productName"
      :fetch-suggestions="querySearchAsync"
      @select="handleSelect"
      size="small"
      :placeholder="$t('message.enterProductNameBarCode')">
      <el-button slot="append" icon="el-icon-more" @click="open"></el-button>
    </el-autocomplete>

    <!--批量选择-->
    <el-dialog :title="$t('message.batchSelection')" :visible.sync="batchSelection" width="90%" top="5vh" :close-on-click-modal=false>
      <div class="secondary">
        <div class="sSpacing">
          <el-input size="small" v-model="searchGoods" :placeholder="$t('message.goodsNameBarCode')"></el-input>
        </div>
        <div class="sSpacing">
          <el-autocomplete
            size="small"
            clearable
            suffix-icon="el-icon-search"
            v-model="searchBrand"
            :fetch-suggestions="querySearchAsyncS"
            @select="handleSelectS"
            :placeholder="$t('message.brand')"
            @clear="empty('brand_id')">
          </el-autocomplete>
        </div>
        <div class="sSpacing">
          <el-select size="small" v-model="commodityClassify" :placeholder="$t('message.class')" @change="classificationPagingData">
            <el-option
              v-for="item in classifyList"
              :key="item.cat_id"
              :label="item.descrip"
              :value="item.cat_id">
            </el-option>
          </el-select>
          <el-select size="small" v-model="commodityClassifys" :placeholder="$t('message.subclass')" v-if="commodityClassify!==''" @change="commodityPagingData(1)">
            <el-option
              v-for="item in classifyLists"
              :key="item.cat_id"
              :label="item.descrip"
              :value="item.cat_id">
            </el-option>
          </el-select>
        </div>
        <div class="sSpacing">
          <el-button-group>
            <el-button size="small" type="primary" icon="el-icon-search" @click="commodityPagingData(1)">{{$t("message.query")}}</el-button>
            <el-button size="small" icon="el-icon-delete" @click="emptySearch">{{$t("message.empty")}}</el-button>
          </el-button-group>
        </div>
      </div>
      <div onselectstart="return false">
        <el-table
            ref="multipleTable"
            :data="tableDataList"
            tooltip-effect="dark"
            style="width: 100%"
            size="mini"
            border
            :height="clientHeight"
            @row-click="singleElection"
            @selection-change="handleSelectionChange">
          <el-table-column align="center" header-align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" header-align="center" :label="$t('message.numberBarCode')">
            <template slot-scope="scope">
              <p style="line-height: 16px">{{scope.row.gcode}}</p>
              <p style="line-height: 16px">{{scope.row.barcode}}</p>
            </template>
          </el-table-column>
          <el-table-column align="center" header-align="center" :label="$t('message.goodsName')">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="right">
                <p>{{$t("message.brand")}}：{{scope.row.brand_name}}</p>
                <p>{{$t("message.class")}}：{{scope.row.cat_name}}</p>
                <div slot="reference" style="line-height: 16px">{{scope.row.goods_name}}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" header-align="center" :label="$t('message.spec')">
            <template slot-scope="scope">
              {{scope.row.sku_vname}}
            </template>
          </el-table-column>
          <el-table-column align="center" header-align="center" :label="$t('message.availableStock')">
            <template slot-scope="scope">
              {{scope.row.availableStock}}
              <span style="color: #F56C6C;" v-show="scope.row.availableStock<=0">{{$t("message.shortage")}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" header-align="center" :label="$t('message.unitPriceSales')">
            <template slot-scope="scope">
              {{scope.row.price}}
            </template>
          </el-table-column>
          <el-table-column align="center" header-align="center" :label="$t('message.costUnitPrice')" v-if="cost">
            <template slot-scope="scope">
              {{scope.row.cost}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" header-align="center" :label="$t('message.company')" width="150">
            <template slot-scope="scope">
              <el-select size="small" v-model="scope.row.companyId" v-show="scope.row.addSubtract!='0'">
                <el-option :label="scope.row.unit_name" :value="1" @click.native="choiceCostPrice(scope.$index,scope.row.companyId)"></el-option>
                <el-option :label="scope.row.sub_uname" :value="2" @click.native="choiceCostPrice(scope.$index,scope.row.companyId)" v-show="scope.row.amount_unit!=scope.row.sub_unit"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" header-align="center" :label="$t('message.num')" width="150">
            <template slot-scope="scope">
              <el-input-number size="small" v-model="scope.row.amount" @change="enSureNum(scope.row.amount,scope.$index)" :min="1" class="layout" v-show="scope.row.addSubtract!='0'"></el-input-number>
              <!--<el-input-number size="small" v-model="scope.row.amount" @change="enSureNum(scope.row.amount,scope.$index)" :min="transaction==true?scope.row.companyId==1?scope.row.a_q:scope.row.a_q*scope.row.dim_ratio:1" class="layout" v-show="scope.row.addSubtract!='0'"></el-input-number>-->
            </template>
          </el-table-column>
          </el-table>
        <div class="bottomSecondary">
          <el-row>
            <el-col :span="12">
              <div class="functionButton">
                <el-checkbox v-model="checked" :label="$t('message.allElection')" border style="margin-right: 10px" @change="toggleSelection(tableDataList,checked)"></el-checkbox>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="pagingPosition">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 30, 60, 100]"
                  :page-size="onePageList"
                  layout="total, sizes, prev, pager, next"
                  :total="rowsCount">
                </el-pagination>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="abolishBatch">{{$t("message.cancel")}}</el-button>
        <el-button type="primary" @click="confirmationMaterials">{{$t("message.confirm")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props:['confirmProduct','custId','productName','transaction','cost','store_id','replacement'],
    data() {
      return {
        batchSelection:false, //批量选择弹框

        productName: '', //商品名称
        timeout:  null,
        commodityList:[], //商品列表

        currentPage:1,  //分页
        rowsCount:0,  //总页数
        onePageList:30,  //一页显示多少条
        startPage:0,   //分页数据起始数

        searchGoods:'', //搜索名称或条码货号
        searchBrand:'', //品牌
        brand_id:'', //品牌ID
        commodityClassify: '', //分类
        commodityClassifys: '', //2级分类

        timeoutS:  null,
        brandList:[], //品牌列表
        classifyList: [], //分类列表
        classifyLists: [], //分类列表2

        tableDataList: [], //数据列表
        checked:false,

        productList:[], //选中商品

        transaction:false, //成交价判断
        cost:false, //成本价判断

        clientHeight:'', //屏幕自适应高度
      };
    },
    created(){
      this.clientHeight=document.documentElement.clientHeight-370; //屏幕高度
    },
    methods: {
      //搜索商品
      querySearchAsync(queryString, cb) {
        let _this=this;
        let obj={
          start:0, //数据起始数
          limit:20, //每页数据条数
          ordersort:'sku_id desc', //排序
          buyer_id:_this.custId, //客户id
          shop_id:_this.store_id==undefined?_this.$store.state.Login.shopId:_this.store_id, //门店id
          catid:'', //商品分类id
          search_key:queryString, //商品码或商品名称
          brand_id:'', //品牌id
          states:1, //状态
        };
        _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/goods.GoodsMgr/queryGoods?sessionid='+_this.$store.state.Login.sessionid,obj).then(function(res){
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            let skuIds=[];
            for(let i of res.data.resultlist){
              //订货
              i.amount=1; //数量
              i.companyId=1; //1批发 2零售
              i.availableStock=i.left_qtt_p; //可售库存,批发
              i.price=_this.numMulti(parseFloat(i.a_p),0.01); //第一梯单价，批发
              i.prices=_this.numMulti(parseFloat(i.a_p),0.01); //第一梯单价，批发 仅显示用
              i.o_price=_this.numMulti(parseFloat(i.a_p),0.01); //第一梯单价，批发 仅显示用
              //退货/换货
              i.retStorage=1; //退货入库方式
              i.reasonId=1; //退货原因
              //入库
              i.cost=i.cost<0?'':_this.numMulti(i.cost,0.01); //成本价
              //出库
              i.returnStock=i.ret_qtt_p; //退货库存，批发

              skuIds.push(i.sku_id);
            }
            if(_this.transaction){
              for(let i of res.data.resultlist){
                i.amount=i.a_q; //数量 第一梯起买量
              }
              //批量获取商品上次成交价
              let obj={
                skuIds:skuIds,
                buyerId:_this.custId,
              };
              _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/deal.DhDealMgr/getLastPriceP?sessionid='+_this.$store.state.Login.sessionid,obj).then(function(resS){
//                console.log(res.data);
                if(resS.data.ret_status=='ok'){
                  for(let i of res.data.resultlist){
                    for(let o of resS.data.resultlist){
                      if(i.sku_id === o.sku_id){
                        i.last_price = _this.numMulti(o.last_price,0.01);
                        i.last_unit_name = o.last_unit_name;
                        break;
                      }
                    }
                  }
                }else {
                  _this.openWar(resS.data.rpc_msg)
                }
              }).catch(function (error) {
                _this.openErr(_this.$t("message.requestFailure"));
              });
            }
            if(_this.cost){
              //批量获取商品上次入库成本价
              _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/stocks.RkdMgr/getLastCostP?sessionid='+_this.$store.state.Login.sessionid,{sku_ids:skuIds}).then(function(resC){
//                console.log(res.data);
                if(resC.data.ret_status=='ok'){
                  for(let i of res.data.resultlist){
                    for(let o of resC.data.resultlist){
                      if(i.sku_id === o.sku_id){
//                        i.cost=_this.numMulti(parseFloat(o.cost),0.01); //主单位成本价
                        i.cost_main=_this.numMulti(parseFloat(o.cost),0.01); //主单位成本价
                        i.cost_main_name=o.unit_name; //主单位
                        i.cost_auxiliary=_this.numMulti(parseFloat(o.cost_l),0.01); //辅单位成本价
                        i.cost_auxiliary_name=o.sub_uname; //辅单位
                        i.cost_last=_this.numMulti(parseFloat(o.cost),0.01); //初始成本价
                        i.cost_lastN=o.unit_name; //初始主单位
                        break;
                      }
                    }
                  }
                }else {
                  _this.openWar(resC.data.rpc_msg)
                }
              }).catch(function (error) {
                _this.openErr(_this.$t("message.requestFailure"));
              });
            }
            _this.commodityList=res.data.resultlist;
            let results = typeof _this.commodityList == 'undefined'?[]:_this.commodityList;
            for(let i of results){
              i.value = i.goods_name;
            }
            clearTimeout(_this.timeout);
            _this.timeout = cb(results);
          }
        }).catch(function (error) {
          _this.openErr(_this.$t("message.requestFailure"));
        });
      },
      //获取商品信息
      handleSelect(item) {
        this.productList=[item];
        this.$emit('confirmProduct',this.productList);
      },
      //搜索品牌
      querySearchAsyncS(queryString, cb) {
        let _this=this;
        let obj={
          start:0, //数据起始数
          limit:100, //每页数据条数
          ordersort:'brand_id desc', //排序
          descrip:queryString, //品牌名称
          states :'1', //状态
        };
        _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/dict.CbrandMgr/query_cbrand?sessionid='+_this.$store.state.Login.sessionid,obj).then(function(res){
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            _this.brandList=res.data.resultlist;
            let results = typeof _this.brandList == 'undefined'?[]:_this.brandList;
            for(let i of results){
              i.value = i.descrip;
            }
            clearTimeout(_this.timeoutS);
            _this.timeoutS = cb(results);
          }
        }).catch(function (error) {
          _this.openErr(_this.$t("message.requestFailure"));
        });
      },
      //获取品牌信息
      handleSelectS(item) {
        this.brand_id=item.brand_id;
        this.commodityPagingData(1);
      },
      //分类分页数据
      classificationPagingData(i){
        let _this=this;
        _this.commodityClassifys = '';
        let obj={
          start:0, //数据起始数
          limit:200, //每页数据条数
          ordersort:'cat_id desc', //排序
          pid:i, //上一级分类id
          states:'1', //状态，1有效，0无效
          descrip:'', //分类名称
          node_level:'', //级数
        };
        _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/dict.CgcatMgr/query_cgcat?sessionid='+_this.$store.state.Login.sessionid,obj).then(function(res){
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            let str = i === 0 ? 'classifyList' : 'classifyLists';
            _this[str]=res.data.resultlist; //数据列表
            i!==0?_this.commodityPagingData(1):null;
          }else {
            _this.openWar(res.data.rpc_msg)
          }
        }).catch(function (error) {
          _this.openErr(_this.$t("message.requestFailure"));
        });
      },
      //打开批量
      open(){
        this.batchSelection=true;
        this.commodityPagingData(); //商品分页数据
        this.classificationPagingData(0); //分类分页数据
      },
      //商品分页数据
      commodityPagingData(a){
        let _this=this;
        if(a===1){_this.currentPage=1} //分页初始化
        let obj={
          start:a===1?0:_this.startPage, //数据起始数
          limit:_this.onePageList, //每页数据条数
          ordersort:'sku_id desc', //排序
          buyer_id:_this.custId, //客户id
          shop_id:_this.store_id==undefined?_this.$store.state.Login.shopId:_this.store_id, //门店id
          catid:_this.commodityClassifys === '' ? _this.commodityClassify : _this.commodityClassifys, //商品分类id
          search_key:_this.searchGoods, //商品码或商品名称
          brand_id:_this.brand_id, //品牌id
          states:1, //状态
        };
        _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/goods.GoodsMgr/queryGoods?sessionid='+_this.$store.state.Login.sessionid,obj).then(function(res){
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            _this.rowsCount=res.data.rows_count; //总记录数
            let skuIds=[];
            for(let i of res.data.resultlist){
              //订货
              i.amount=1; //数量
              i.companyId=1; //1批发 2零售
              i.availableStock=i.left_qtt_p; //可售库存,批发
              i.price=_this.numMulti(parseFloat(i.a_p),0.01); //第一梯单价，批发
              i.prices=_this.numMulti(parseFloat(i.a_p),0.01); //第一梯单价，批发 仅显示用
              i.o_price=_this.numMulti(parseFloat(i.a_p),0.01); //第一梯单价，批发 仅显示用
              //退货/换货
              i.retStorage=1; //退货入库方式
              i.reasonId=1; //退货原因
              //入库
              i.cost=i.cost<0?'':_this.numMulti(i.cost,0.01); //成本价
              //出库
              i.returnStock=i.ret_qtt_p; //退货库存，批发

              skuIds.push(i.sku_id);
            }
            if(_this.transaction){
              for(let i of res.data.resultlist){
                i.amount=i.a_q; //数量 第一梯起买量
              }
              //批量获取商品上次成交价
              let obj={
                skuIds:skuIds,
                buyerId:_this.custId,
              };
              _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/deal.DhDealMgr/getLastPriceP?sessionid='+_this.$store.state.Login.sessionid,obj).then(function(resS){
//                console.log(res.data);
                if(resS.data.ret_status=='ok'){
                  for(let i of res.data.resultlist){
                    for(let o of resS.data.resultlist){
                      if(i.sku_id === o.sku_id){
                        i.last_price = _this.numMulti(o.last_price,0.01);
                        i.last_unit_name = o.last_unit_name;
                        break;
                      }
                    }
                  }
                }else {
                  _this.openWar(resS.data.rpc_msg)
                }
              }).catch(function (error) {
                _this.openErr(_this.$t("message.requestFailure"));
              });
            }
            if(_this.cost){
              //批量获取商品上次入库成本价
              _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/stocks.RkdMgr/getLastCostP?sessionid='+_this.$store.state.Login.sessionid,{sku_ids:skuIds}).then(function(resC){
//                console.log(res.data);
                if(resC.data.ret_status=='ok'){
                  for(let i of res.data.resultlist){
                    for(let o of resC.data.resultlist){
                      if(i.sku_id === o.sku_id){
//                        i.cost=_this.numMulti(parseFloat(o.cost),0.01); //主单位成本价
                        i.cost_main=_this.numMulti(parseFloat(o.cost),0.01); //主单位成本价
                        i.cost_main_name=o.unit_name; //主单位
                        i.cost_auxiliary=_this.numMulti(parseFloat(o.cost_l),0.01); //辅单位成本价
                        i.cost_auxiliary_name=o.sub_uname; //辅单位
                        i.cost_last=_this.numMulti(parseFloat(o.cost),0.01); //初始成本价
                        i.cost_lastN=o.unit_name; //初始主单位
                        break;
                      }
                    }
                  }
                }else {
                  _this.openWar(resC.data.rpc_msg)
                }
              }).catch(function (error) {
                _this.openErr(_this.$t("message.requestFailure"));
              });
            }
            _this.tableDataList=res.data.resultlist; //数据列表
          }else {
            _this.openWar(res.data.rpc_msg)
          }
        }).catch(function (error) {
          _this.openErr(_this.$t("message.requestFailure"));
        });
      },
      //选择单位并返回数据
      choiceCostPrice(index,val){
        let noumenon=this.tableDataList; //商品详情列表
        if(val==1){
          noumenon[index].availableStock=noumenon[index].left_qtt_p;
          noumenon[index].price=this.numMulti(parseFloat(noumenon[index].a_p),0.01);
          noumenon[index].cost_last=noumenon[index].cost_main;
          noumenon[index].cost_lastN=noumenon[index].cost_main_name;
          noumenon[index].amount=noumenon[index].a_q;
        }else if(val==2){
          noumenon[index].availableStock=noumenon[index].left_qtt;
          noumenon[index].price=this.numMulti(parseFloat(noumenon[index].a_p_l),0.01);
          noumenon[index].cost_last=noumenon[index].cost_auxiliary;
          noumenon[index].cost_last=noumenon[index].cost_auxiliary_name;
          noumenon[index].amount=this.numMulti(noumenon[index].a_q,noumenon[index].dim_ratio);
        }
      },
      //取消批量
      abolishBatch(){
        this.batchSelection=false;
        this.$refs.multipleTable.clearSelection();
        this.checked=false;
      },
      //全选
      toggleSelection(rows,checked) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row,checked);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      //单选
      singleElection(row,event,column) {
        if(!(event.label===this.$t("message.company")||event.label===this.$t("message.num"))){
          this.$refs.multipleTable.toggleRowSelection(row);
        }
      },
      //批量选择
      handleSelectionChange(val) {
        if(this.replacement){ //换货单 判断选择商品数量
          if(val.length>1){
            val.forEach(row => {
              this.$refs.multipleTable.toggleRowSelection(row,false);
            });
            this.openWar(this.$t("message.pleaseChooseCommodity"));
          }
        }
        this.checked = val.length === this.tableDataList.length;
        this.productList=val;
      },
      //确认
      confirmationMaterials(){
        this.$emit('confirmProduct',this.productList);
        this.batchSelection=false;
      },
      // 判读数字大小
      enSureNum(value,i){
        let amendForm = this.tableDataList[i];
        let str = amendForm.companyId == 2 ? '_l' : '';
        if(value > amendForm['c_q'+str]&&amendForm['c_q'+str]!=0&&typeof amendForm['c_q'+str]!='undefined'&&amendForm['d_q'+str]>amendForm['c_q'+str]){
          this.tableDataList[i].price = this.numMulti(amendForm['d_p'+str],0.01)
        }else if(value > amendForm['b_q'+str]&&amendForm['b_q'+str]!=0&&typeof amendForm['b_q'+str]!='undefined'&&amendForm['c_q'+str]>amendForm['b_q'+str]){
          this.tableDataList[i].price = this.numMulti(amendForm['c_p'+str],0.01)
        }else if(value > amendForm['a_q'+str]&&amendForm['a_q'+str]!=0&&typeof amendForm['a_q'+str]!='undefined'&&amendForm['b_q'+str]>amendForm['a_q'+str]){
          this.tableDataList[i].price = this.numMulti(amendForm['b_p'+str],0.01)
        }else{
          this.tableDataList[i].price = this.numMulti(amendForm['a_p'+str],0.01)
        }
      },
      //清空
      empty(id){
        this[id]='';
        this.commodityPagingData(1);
      },
      //清空
      emptySearch(){
        this.searchGoods='';
        this.searchBrand='';
        this.brand_id='';
        this.commodityClassify='';
        this.commodityClassifys='';
        this.commodityPagingData(1);
      },
      //每页显示多少条
      handleSizeChange(val) {
        this.onePageList=val;
        this.commodityPagingData();
      },
      //当前页
      handleCurrentChange(val) {
        this.currentPage=val;
        this.startPage=(val-1)*this.onePageList;
        this.commodityPagingData();
      },
    }
  };
</script>

<style lang="less" scoped>
  .el-input, .el-select, .el-autocomplete{
    width: 100%;
  }
  .bottomSecondary{
    margin-top: 20px;
    .functionButton{
      float: left;
      padding: 5px 5px 0 5px;
    }
    .pagingPosition{
      padding: 10px 0 5px 0;
      float: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/choiceGoods.vue